<footer class="footer">
  <div class="container-fluid py-4">
      <div class="row d-flex justify-content-around">Developed by CodeStack, a department of<br>San Joaquin County Office of Education.</div>
      <div class="row d-flex justify-content-around">&copy; 2020 SCOHR. All Rights Reserved.</div>
  </div>
</footer>
